import React from 'react';
import { Code, Blocks, Workflow } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const ForDevelopers: React.FC = () => {
  return (
    <section id="for-developers" className="bg-gradient-to-b from-background/50 to-background py-16 md:py-24">
      <Container>
        <div className="grid gap-12 md:grid-cols-2 md:items-center">
          <div>
            <div className="relative">
              <div className="absolute -inset-1 rounded-xl bg-gradient-to-r from-secondary/20 to-primary/20 opacity-70 blur-xl"></div>
              <div className="relative rounded-xl border border-border bg-card p-2 shadow-xl">
                <div className="relative">
                  <img
                    src="https://images.pexels.com/photos/6330644/pexels-photo-6330644.jpeg"
                    alt="Game development interface"
                    className="rounded-lg w-full opacity-50"
                    width={600}
                    height={400}
                  />
                  <div className="absolute inset-0 bg-gradient-to-tr from-background via-transparent to-background/80"></div>
                  <div className="absolute inset-0 flex">
                    <div className="w-1/2 border-r border-primary/30 p-4">
                      <pre className="text-xs text-primary">
                        <code>
                          {`// GDK Integration
import { WizantixGDK } from '@wizantix/gdk';

const gdk = new WizantixGDK();
const scene = gdk.createScene();

// AI-assisted code generation
function setupPlayer&#40;config&#41; &#123;
  const player = new Entity&#40;config&#41;;
  return player;
&#125;`}
                        </code>
                      </pre>
                    </div>
                    <div className="w-1/2 p-4">
                      <div className="rounded bg-card/50 p-2">
                        <div className="mb-2 flex items-center space-x-2">
                          <div className="h-2 w-2 rounded-full bg-red-500"></div>
                          <div className="h-2 w-2 rounded-full bg-yellow-500"></div>
                          <div className="h-2 w-2 rounded-full bg-green-500"></div>
                        </div>
                        <div className="space-y-1">
                          <div className="h-2 w-3/4 rounded bg-primary/20"></div>
                          <div className="h-2 w-1/2 rounded bg-primary/20"></div>
                          <div className="h-2 w-2/3 rounded bg-primary/20"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <div className="inline-flex items-center rounded-full bg-secondary/10 px-3 py-1 text-sm font-medium text-secondary ring-1 ring-inset ring-secondary/20 mb-4">
              <Code size={16} className="mr-1" />
              <span>For Professional Developers</span>
            </div>
            
            <h2 className="mb-6 text-3xl font-bold sm:text-4xl">
              Powerful Tools for Experienced Developers
            </h2>
            
            <p className="mb-6 text-lg text-muted-foreground">
              Wizantix.games offers robust development tools for experienced programmers. Use our Game Development Kit (GDK) and AI-assisted low-code tools to accelerate your workflow.
            </p>
            
            <ul className="mb-8 space-y-4">
              {[
                {
                  icon: <Code className="h-5 w-5 text-secondary" />,
                  text: 'Access our comprehensive GDK with extensive APIs and documentation',
                },
                {
                  icon: <Blocks className="h-5 w-5 text-secondary" />,
                  text: 'Leverage AI to generate code snippets, optimize performance, and debug issues',
                },
                {
                  icon: <Workflow className="h-5 w-5 text-secondary" />,
                  text: 'Seamlessly integrate with popular game engines and development environments',
                },
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <div className="mr-3 flex h-6 w-6 items-center justify-center rounded-full bg-secondary/10">
                    {item.icon}
                  </div>
                  <span className="text-foreground">{item.text}</span>
                </li>
              ))}
            </ul>
            
            <Button variant="secondary">Explore Developer Tools</Button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ForDevelopers;